import { ICaliperViewModel, IWindowViewModel } from '../models/interfaces';

export class WindowViewModel implements IWindowViewModel {
    // data members

    x: number = 0;
    y: number = 0;
    width: number = 0;
    height: number = 0;
    opacity: number = 0;

    constructor(caliper: ICaliperViewModel) {
        this._caliper = caliper;

        this.opacity = 0;
    }

    private _caliper: ICaliperViewModel;

    // constructor

    get caliper() {
        return this._caliper;
    }

    // public functions

    update() {
        let measure = Math.abs(
            this.caliper.pointer1.currentIntersection.x - this.caliper.pointer2.currentIntersection.x,
        );
        this.caliper.window.x = Math.min(
            this.caliper.pointer1.currentIntersection.x,
            this.caliper.pointer2.currentIntersection.x,
        );
        this.caliper.window.y = 35;
        this.caliper.window.width = measure;
        this.caliper.window.height = 30;
    }
}
